export default {
  notifications: [],
  language: 'English',
  menu: [],
  actions: []
}